<template>
    <ToggleGroup
        :controls="controls"
        :toggles.sync="properties"
        :title="$t('common.keywords.properties')"
    />
</template>

<script>
import ToggleGroup from "@/components/common/ToggleGroup";

export default {
    name: "PropertiesToggles",
    props: {
        controls: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        ToggleGroup
    },
    computed: {
        properties: {
            get() {
                return this.$store.getters.getProperties;
            },
            set(val) {
                this.$store.commit('setProperties', val);
            }
        },
    }
}
</script>